module.exports = __webpack_public_path__ + "img/T2A_rc_12.c0d8d48e.png";